<template>
	<div class="session-start">
		<div class="session-start__actionPanel">
			<div class="session_actionLogoRow">
				<a href="http://www.teaming.com/">
					<DuoToneTeamingWordLogo />
				</a>
			</div>
			<slot name="actionPanel" />
		</div>
		<div class="session-start__infoPanel">
			<slot name="infoPanel">
				<div class="session-start__infoPanelHeader">
					{{ $t( "slice-apple.components.SessionStart.infoTitle" ) }}
				</div>
			</slot>
		</div>
	</div>
</template>

<script>
import { DuoToneTeamingWordLogo } from "@teaming/common-ui";

export default {
	name: "SessionStart",
	components: {
		DuoToneTeamingWordLogo,
	},
};
</script>

<style lang="scss" scoped>
.session-start {
	text-align: left;
	width: 100%;
	height: 100%;
	@include for-size('xs') {
		display: block;
	}

	@include for-size('sm') {
		display: block;
	}

	@include for-size('md') {
		display: flex;
	}
}

.session-start__actionPanel {
	display: flex;
	flex-direction: column;
	max-width: 75%;
	align-items: center;

	@include for-size('xs') {
		min-width: 100%;
		padding: 2rem 1.5rem 1.5rem 1.5rem;
	}

	@include for-size('sm') {
		min-width: 100%;
		padding: 2.5rem 3rem 3rem 3rem;
	}

	@include for-size('md') {
		min-width: 50%;
		padding: 3rem;
	}

	@include for-size('lg') {
		padding: 4rem;
	}
}

.session_actionLogoRow {
	@include for-size('xs') {
		align-self: center;
	}

	@include for-size('sm') {
		align-self: center;
	}

	@include for-size('md') {
		align-self: center;
	}

	@include for-size('lg') {
		align-self: flex-start;
	}
}

.session-start__infoPanel {
	display: flex;
	flex-direction: column;
	background: $session-start-info-panel-background-color;
	color: $session-start-info-panel-font-color;

	@include for-size('xs') {
		min-width: 100%;
		padding: 2rem 1.5rem 1.5rem 1.5rem;
	}

	@include for-size('sm') {
		min-width: 100%;
		padding: 2.5rem 3rem 3rem 3rem;
	}

	@include for-size('md') {
		min-width: 50%;
		padding: 3rem;
	}

	@include for-size('lg') {
		padding: 4rem;
	}
}

.session-start__infoPanelHeader {
	font-weight: 700;
	margin-bottom: 2.625rem;

	@include for-size('xs') {
		@include font-and-line-for(3);
	}

	@include for-size('sm') {
		@include font-and-line-for(3);
	}

	@include for-size('md') {
		@include font-and-line-for(5);
	}

	@include for-size('lg') {
		@include font-and-line-for(6);
	}
}
</style>
